<template>
  <div>
    <div class="pricing-header p-3 pb-md-4 mx-auto text-center">
      <h1 class="display-3 fw-normal">Highscore</h1>
      <p class="fs-5 text-muted">
        Pay Your Way To The Top
      </p>
    </div>

    <div class="row">
      <div class="col-sm-8 offset-sm-2 d-flex justify-content-center">
        <button class="btn btn-lg gd-info" @click="setModalData" data-bs-toggle="modal" data-bs-target="#newEntryModal">Add new entry</button>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="newEntryModal" tabindex="-1" aria-labelledby="newEntryModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title" id="newEntryModalLabel">Add new entry</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body">

            <div class="mb-4">
              <label for="entryTitle" class="form-label">Title:</label>
              <input type="text" v-model="newEntryTitle" class="form-control" id="entryTitle" placeholder="Enter title">
            </div>

            <div class="mb-4">
              <label for="entryUrl" class="form-label">URL:</label>
              <input type="text" v-model="newEntryUrl" class="form-control" id="entryUrl" placeholder="Link to your website">
            </div>

            <div class="mb-4">
              <label for="entryScore" class="form-label">The amount of BNB to pay:</label>
              <input type="text" v-model="newEntryScore" class="form-control" id="entryScore">
              <small><em>The current top score is {{getTopScore}} BNB.</em></small>
            </div>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn gd-info" @click="addNewEntry">
              <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Submit entry
            </button>
            <button type="button" id="closeModal" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>

        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-sm-8 offset-sm-2">
        <div class="list list-row block" v-for="(entry, index) in getEntries" v-bind:key="entry.url">
          
          <div class="list-item rounded">
              <div><span class="w-48 avatar gd-info">{{index + 1}}</span></div>

              <div class="flex"> 
                <span class="item-author text-color">{{entry.title}}</span>

                <div class="item-except text-muted text-sm h-1x">
                  <a target="_blank" class="text-muted" :href="entry.url">{{entry.url}}</a>
                </div>

              </div>

              <div class="no-wrap ms-auto p-2 bd-highlight">
                <div class="item-score text-muted text-lg d-none d-md-block">{{Number(entry.score).toFixed(2)}} BNB</div>
              </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Home",
  beforeDestroy() {
    this.unsubscribe();
  },
  computed: {
    ...mapGetters("accounts", ["getChainName", "isUserConnected", "getWeb3Modal", "getWeb3", "getActiveAccount"]),
    ...mapGetters("contracts", ["getContract", "getEntries", "getTopScore"]),
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'accounts/setWeb3Provider') {
        this.$store.dispatch("contracts/fetchContract");
        this.$store.dispatch("contracts/fetchEntries"); 
      }
    });
  },
  data() {
    return {
      loading: false,
      newEntryTitle: null,
      newEntryUrl: null,
      newEntryScore: null
    }
  },
  methods: {
    setModalData() {
      this.newEntryScore = this.getTopScore;
    },
    async addNewEntry() {
      const component = this;

      try {
        let amountWei = component.getWeb3.utils.toWei(String(component.newEntryScore), "ether");

        if (component.newEntryUrl === "/") {
          component.newEntryUrl = "(no url)";
        }

        await component.getContract.methods.addNewEntry(
          component.newEntryTitle, 
          component.newEntryUrl
        ).send({
          from: component.getActiveAccount,
          value: amountWei
        }, function(error, hash) {
          component.loading = true;
          // Deposit tx error
          if (error) {
            component.$toast.error("The transaction has been rejected. Please try again.");
            component.loading = false;
          }
          // Deposit transaction sent
          if (hash) {
            // show a "tx submitted" toast
            component.$toast.info("The transaction has been submitted. Please wait for confirmation.");
            // listen for the Transfer event
            component.getContract.once("Create", {
              filter: { author: component.getActiveAccount }
            }, function(error, event) {
              component.loading = false;
              
              // failed transaction
              if (error) {
                component.$toast.error("The transaction has failed. Please try again, perhaps with a higher gas limit.");
              }
              // success
              if (event) {
                component.$toast.success("Your entry was successfull created!");
                
                component.$store.dispatch("contracts/fetchEntries");
                window.document.getElementById('closeModal').click();
              }
            });
          }
        });
      } catch (e) {
          window.console.log("Error:", e);
          component.$toast.error("The transaction has been reverted. Please try again or contact project admins.");
          component.loading = false;
      }

    }
  }
}
</script>

<style scoped>

.avatar {
    position: relative;
    line-height: 1;
    border-radius: 500px;
    white-space: nowrap;
    font-weight: 700;
    border-radius: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    border-radius: 500px;
    box-shadow: 0 5px 10px 0 rgba(50, 50, 50, .15)
}

.avatar img {
    border-radius: inherit;
    width: 100%
}

.gd-primary {
    color: #fff;
    border: none;
    background: #448bff linear-gradient(45deg, #448bff, #44e9ff)
}

.gd-success {
    color: #fff;
    border: none;
    background: #31c971 linear-gradient(45deg, #31c971, #3dc931)
}

.gd-info {
    color: #fff;
    border: none;
    background: #14bae4 linear-gradient(45deg, #14bae4, #14e4a6)
}

.gd-info:hover {
    color: #fff;
    border: none;
    background: #448bff linear-gradient(45deg, #448bff, #3dc931)
}

.gd-warning {
    color: #fff;
    border: none;
    background: #f4c414 linear-gradient(45deg, #f4c414, #f45414)
}

.item-score {

}

.list {
    padding-left: 0;
    padding-right: 0
}

.list-item {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
}

.list-row .list-item {
    -ms-flex-direction: row;
    flex-direction: row;
    -ms-flex-align: center;
    align-items: center;
    padding: .75rem .625rem
}

.list-row .list-item>* {
    padding-left: .625rem;
    padding-right: .625rem
}

.list-row .list-item:hover {
    background: #fafaf7 linear-gradient(45deg, #fafaf7, #f7f7f7)
}

.no-wrap {
    white-space: nowrap
}

.text-color {
    color: #5e676f
}

.text-sm {
    font-size: .825rem
}

.h-1x {
    height: 1.25rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical
}

.w-48 {
    width: 48px !important;
    height: 48px !important
}

a:link {
    text-decoration: none
}
</style>
